var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIconStartPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.70798,
    cy: 7.70798,
    r: 7.70798,
    fill: "#004273"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0799 7.27099V10.5185C11.0799 10.6676 11.0207 10.8105 10.9153 10.916C10.8099 11.0214 10.667 11.0806 10.5179 11.0806H9.11279C8.96373 11.0806 8.82077 11.0214 8.71537 10.916C8.60996 10.8105 8.55075 10.6676 8.55075 10.5185V9.11343C8.55075 9.0389 8.52114 8.96742 8.46844 8.91472C8.41574 8.86201 8.34426 8.83241 8.26973 8.83241H7.14565C7.07112 8.83241 6.99964 8.86201 6.94694 8.91472C6.89424 8.96742 6.86463 9.0389 6.86463 9.11343V10.5185C6.86463 10.6676 6.80541 10.8105 6.70001 10.916C6.59461 11.0214 6.45165 11.0806 6.30259 11.0806H4.89749C4.74843 11.0806 4.60547 11.0214 4.50007 10.916C4.39466 10.8105 4.33545 10.6676 4.33545 10.5185V7.27099C4.33544 7.1932 4.35157 7.11626 4.38283 7.04503C4.41409 6.9738 4.4598 6.90984 4.51706 6.85719L7.32726 4.20576L7.33112 4.2019C7.43459 4.1078 7.56942 4.05566 7.70927 4.05566C7.84912 4.05566 7.98395 4.1078 8.08742 4.2019C8.08862 4.20327 8.08991 4.20457 8.09128 4.20576L10.9015 6.85719C10.9582 6.91012 11.0033 6.97421 11.034 7.04542C11.0647 7.11664 11.0803 7.19344 11.0799 7.27099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconStartPoint);
export default __webpack_public_path__ + "static/media/mapIconStartPoint.eb64f5ed3a14eab5efc96ded2c4a4d30.svg";
export { ForwardRef as ReactComponent };